const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type PerformanceRangeItem = {
  min: number;
  point: number;
};

export type PerformanceItem = {
  id: number;
  item: string;
  fixedKey: string | null;
  type: 'budget_ratio' | 'yoy_growth' | 'absolute' | 'manual';
  weight: number;
  max: number;
  ranges: PerformanceRangeItem[];
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchPerformanceItemList() {
  const response = await fetch(`${apiBaseUrl}/api/admin/performance-items`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: PerformanceItem[] };
  return payload.items;
}

export async function replacePerformanceItemList(input: {
  items: {
    id?: number;
    item: string;
    type: 'budget_ratio' | 'yoy_growth' | 'absolute' | 'manual';
    weight: number;
    max: number;
    ranges: PerformanceRangeItem[];
  }[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/performance-items`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: PerformanceItem[] };
  return payload.items;
}
